export default __webpack_public_path__ + "static/media/assets_audio_game_over_sound.a22b9882.mp3";